import { useMutation, useQuery } from "@tanstack/react-query";
import {
  addCity,
  getAllTimeZone,
  getCitiesByStates,
  getCountries,
  getStatesByCountryId,
  setDownloadAcknowledgement,
} from "controller/api/general";
import { useGlobalStore } from "controller/store";
import type { AddCityInput } from "shared";
import { debugConsole } from "utilz/helpers";

export const useSetUserAcknowledgement = () => {
  return useMutation(
    (resourceId: string) => setDownloadAcknowledgement(resourceId),
    {
      onSuccess(_data, _variables, _context) {
        // do nothing
      },
    },
  );
};

export const useGetAllTimezone = () => {
  return useQuery({
    queryKey: ["timezones"],
    queryFn: () => getAllTimeZone(),
    onError: (err) => debugConsole(err),
    staleTime: Infinity,
  });
};
export const useGetAllCountries = () => {
  return useQuery({
    queryKey: ["countries"],
    queryFn: () => getCountries(),
    onError: (e) => debugConsole(e),
  });
};

export const useGetAllStateByCountryId = (countryId?: string) => {
  return useQuery({
    queryKey: ["state", countryId],
    queryFn: () => getStatesByCountryId(countryId || ""),
    onError: (e) => debugConsole(e),
    enabled: !!(countryId && countryId !== null),
  });
};

export const useGetAllCityByStateId = (
  countryId?: string,
  stateId?: string,
) => {
  const mspId = useGlobalStore((state) => state.mspId);
  return useQuery({
    queryKey: ["countries", countryId, stateId, mspId],
    queryFn: () =>
      getCitiesByStates({
        countryId: countryId || "",
        stateId: stateId || "",
        mspId: mspId || "",
      }),
    onError: (e) => debugConsole(e),
    enabled: !!countryId && !!stateId,
  });
};

export const useAddCity = () => {
  return useMutation((data: AddCityInput) => addCity(data), {
    onError: (e) => debugConsole(e),
  });
};
